export default __webpack_public_path__ + "static/media/29Alot.26b2fb28.png";